import * as React from 'react';
import Utils from '../../../utils';
import { StoreState } from '../../../reducers';
import { Dispatch } from 'react-redux';
import { openContextualMenu } from '../../../containers/DriveItemList/actions';
import { ItemContextualMenu } from './styles';
import UserAgentUtils from '../../../utils/userAgent';

interface ListItemActionButtonProps {
	dispatch: Dispatch<StoreState>;
	driveItemId: number;
	isActiveIcon: boolean;
	isRowView: boolean;
	onContextualMenuHover: (e: MouseEvent) => void;
}

const ListItemActionButton = ({
	dispatch,
	driveItemId,
	isActiveIcon,
	onContextualMenuHover,
	isRowView,
}: ListItemActionButtonProps) => {

	const onContextualMenuClick = (e: MouseEvent) => {
		e.stopPropagation();
		dispatch(openContextualMenu(driveItemId));
	};

	const contextualMenuIconName = isActiveIcon ? 'iconset_3dots-active' : 'iconset_3dots';

	const onHover = (e: MouseEvent) => {
		if (UserAgentUtils.isDesktop()) {
			onContextualMenuHover(e);
		}
	};

	return (
		<ItemContextualMenu
			onClick={onContextualMenuClick}
			onMouseOver={onHover}
			isRowView={isRowView}
		>
			{Utils.getSvgIcon(contextualMenuIconName)}
		</ItemContextualMenu>
	);
};

export default ListItemActionButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ListItem/ActionButton/index.tsx